<template>
  <v-app>
    <nav>
      <v-app-bar flat app>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class = "grey--text">
          <span onclick = "window.location.href = '/'" class = "font-weight-light">Asociación bahiense de basquet</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text color="grey" @click="logout()">
          <span>Salir</span>
          <v-icon right>exit_to_app</v-icon>
        </v-btn>
      </v-app-bar>
      <v-navigation-drawer
        app
        hide-overlay
       disable-resize-watcher
       mobile-break-point = "1000"
       color="#24344B"
       v-model="drawer"
       >
        <v-list-item :style="{'justify-content':'center', 'margin-top': '1.5rem', 'background-color':'white'}">
            <v-img  max-height = "100" max-width = "100" :src='"/img/club/"+fotoUser'></v-img>
        </v-list-item>
        <v-list-item :style="{'margin-bottom': '1.5rem'}">
          <v-list-item-content style ="text-align:center">
            <v-list-item-title class ="title" style="color:white !important;">
              {{ nombreClub }}
            </v-list-item-title>
            <v-list-item-subtitle style="color:#D8D8D8 !important;">
              {{ nombreUser }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-item disabled>
            <v-list-item-title style = "color: white !important;">Principal</v-list-item-title>
          </v-list-item>
          <v-list-item href = '/' :disabled = "!hayUsuario" > <!--Inicio-->
            <v-list-item-icon>
              <v-icon color="#D8D8D8" size = "25">mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
               style="color: #D8D8D8;" >Inicio</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item href = '/MiCuenta' :disabled = "!hayUsuario" > <!--Mi cuenta-->
            <v-list-item-icon>
              <v-icon color="#D8D8D8" size = "25">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-bind:class = "{deshabilitado: (!hayUsuario)}"
               style="color: #D8D8D8;" >Mi cuenta</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item href = '/cuentaCorriente' :disabled = "!hayUsuario"> <!--Cuenta corriente-->
            <v-list-item-icon>
              <v-icon color="#D8D8D8" size = "25">mdi-clipboard-text</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-bind:class = "{deshabilitado: (!hayUsuario)}"
               style="color: #D8D8D8;">Cuenta corriente</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item disabled>
            <v-list-item-title style = "color: white !important">Administración</v-list-item-title>
          </v-list-item>
          <v-list-item href = '/cuentas' :disabled = "!hayUsuario"> <!--Cuentas-->
            <v-list-item-icon>
              <v-icon color="#D8D8D8" size = "25">mdi-account-supervisor</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-bind:class = "{deshabilitado: (!hayUsuario)}"
               style="color: #D8D8D8;" >Usuarios</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item  @click = "logout()" :disabled = "!hayUsuario">
            <v-list-item-icon>
              <v-icon color="#D8D8D8" size = "25">exit_to_app</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-bind:class = "{deshabilitado: (!hayUsuario)}"
               style="color: #D8D8D8;">Salir</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </nav>
    <v-container fluid
      v-bind:class ="{'abierto': drawer}"
      style="margin-top: 55px;">
      <router-view></router-view>
    </v-container>
  </v-app>
</template>
<style type="text/css">
  .activa{
    background-color: #1CB394;
  }
  .abierto{
    max-width: 80% !important;
    justify-content: right;
    margin-left: 20% !important;
  }
  .v-badge{
    margin-right: 20px;
  }
  .titulo{
    background-color: #1CB394;
  }
  .deshabilitado{
    color: #A4A4A4 !important;
  }
</style>
<script>
import axios from 'axios';
import { url } from '@/variables';

export default {
  name: 'Sidebar',
  data() {
    return {
      drawer: false,
      hayUsuario: this.$session.get('id') > 0,
      idUser: this.$session.get('id'),
      nombreClub: '',
      nombreUser: '',
      fotoUser: 'default.jpg',
      disItem: true,
    };
  },
  methods: {
    init() {
      if (!this.$session.exists()) {
        this.$session.start();
      }
      if (this.$session.get('id') > 0) {
        const path = `${url}/datosUsuario`;
        axios.post(path, {
          id: this.idUser,
        })
          .then((response) => {
            if (response.status === 200) {
              this.nombreClub = response.data.result[2];
              this.nombreUser = response.data.result[0];
              this.fotoUser = response.data.result[1];
            }
          });
      } else {
        this.fotoUser = 'default.jpg';
      }
    },
    logout() {
      this.$session.set('id', '0');
      this.$session.remove('token');
      this.$session.remove('codCuenta');
      this.$router.push('/');
      this.$router.go(0);
    },
    isMobile() {
      if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || (window.innerWidth < 1000)) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.init();
    this.drawer = !this.isMobile();
  },
};
</script>
